<template>
  <el-dialog
    :title="selectedItemId === null ? '新增部門' : '編輯部門'"
    :visible.sync="innerVisible"
  >
    <el-form :model="form" ref="form" :rules="rules" @submit.native.prevent="submit">
      <!--<el-form-item label="單位" :label-width="formLabelWidth">-->
      <!--<el-input :value="myownOrg" readonly autocomplete="off"></el-input>-->
      <!--</el-form-item>-->

      <el-form-item label="部門名稱" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" 
          ref="nameinput"
          autocomplete="off"></el-input>
      </el-form-item>

      <!--<el-form-item-->
      <!--label="管理員"-->
      <!--:label-width="formLabelWidth"-->
      <!--prop="adminIds" >-->
      <!--<el-select-->
      <!--v-model="form.adminIds"-->
      <!--multiple-->
      <!--placeholder="请选择"-->
      <!--filterable >-->
      <!--<el-option-->
      <!--v-for="item in users"-->
      <!--:key="item.id"-->
      <!--:label="`${item.username}(${item.name})`"-->
      <!--:value="item.id" >-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->

      <el-form-item label="顏色" :label-width="formLabelWidth" prop="color">
        <div style="width:480px;marginBottom:-20px">
          <el-radio-group v-model="form.color">
            <el-radio
              v-for="itemColor in extTagColorList"
              :key="itemColor.name"
              :label="itemColor.name"
            >
              <span :style="{ color: itemColor.textColor }">
                {{ itemColor.txtLabel }}
              </span>
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
    </el-form>
    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedItemId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      //users: "user/users",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "請輸入部門名稱", trigger: "blur" }],
        //adminIds: [
        //{ required: true, message: "請選擇管理員", trigger: "blur" },
        ////{ validator: validatePass, trigger: 'blur' },
        //],
        color: [{ required: true, message: "請輸入顏色", trigger: "blur" }],
      },
      formLabelWidth: "100px",
      form: {
        name: "",
        //adminIds: [],
        color: "primary",
      },
    };
  },
  created() {
    if (this.innerVisible) {
      //this.$store.dispatch("user/list", {
      //max: 99999,
      //offset: 0,
      //sort: "id",
      //order: "ascending",
      //});
      if (this.selectedItemId !== null) {
        const data = this.$store.getters["department/getDeptById"](
          this.selectedItemId
        );
        this.form.id = data.id;
        this.form.name = data.name;
        //this.form.adminIds = data.admins.map(admin => admin.id);
        this.form.color = data.color;
      }
    }
  },
  mounted() {
    if (this.innerVisible) {
      this.$nextTick(() => {
        this.$refs.nameinput.focus();
      });
    }
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.selectedItemId !== null) {
            this.submitUpdate();
          } else {
            this.submitAdd();
          }
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      //console.log(
      //`submitAdd: adminIds = ${JSON.stringify(this.form.adminIds)}`
      //);
      this.$store.dispatch("department/add", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("department/list", null);
      });
    },
    submitUpdate() {
      this.$store.dispatch("department/update", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("department/list", null);
      });
    },
  },
};
</script>

<style></style>
